<mat-toolbar class="ori-elevation-z4 header">
  <h3>{{ "webTek.title" | translate }}</h3>
  <mat-icon class="icon icon-close" (click)="close()" color="primary" svgIcon="close"></mat-icon>
</mat-toolbar>

@switch (step) {
  <!-- Validation screen -->
  @case ("validation") {
    <div class="content webTek-validation" mat-dialog-content>
      <div class="webTek-message-validation">
        {{ "webTek.validation" | translate }}
      </div>
    </div>
    <div mat-dialog-actions class="action-buttons">
      <button (click)="submit()" mat-raised-button color="primary">
        {{ "webTek.export" | translate }}
      </button>
    </div>
  }
  <!-- Spinner screen  -->
  @case ("loading") {
    <div class="content webTek-waiting" mat-dialog-content>
      <div class="webTek-spinner-wrapper">
        <mat-spinner class="webTek-spinner"></mat-spinner>
      </div>
    </div>
  }
  <!-- Result screen  -->
  @case ("success") {
    <div class="content webTek-success" mat-dialog-content>
      @if (note.technicalEvent.isInternal) {
        <div class="webTek-message-to-complete">
          {{ "webTek.toComplete" | translate }}
        </div>
      } @else {
        <div class="webTek-message-success">
          {{ "webTek.success" | translate }}
        </div>
      }
      <div class="webTek-reference-success">
        {{ note.technicalEvent.reference }}
      </div>
    </div>
    <div mat-dialog-actions class="action-buttons">
      <a (click)="openURL()" mat-raised-button class="open-webTek" color="primary">
        {{ "webTek.go" | translate }}
        <mat-icon class="open-webTek-icon" svgIcon="open-in-new"></mat-icon>
      </a>
    </div>
  }
}
